import { __awaiter, __generator } from "tslib";
import Vue from 'vue';
export var member = {
  namespaced: true,
  state: {
    userLevel: [],
    monitorLevel: [],
    welfare: [],
    current: null,
    monitorCurrent: null
  },
  mutations: {
    setUserLevel: function setUserLevel(state, userLevel) {
      state.userLevel = userLevel;
    },
    setMonitorLevel: function setMonitorLevel(state, monitorLevel) {
      state.monitorLevel = monitorLevel;
    },
    setWelfare: function setWelfare(state, welfare) {
      state.welfare = welfare;
    },
    setCurrent: function setCurrent(state, current) {
      state.current = current;
    },
    setMonitor: function setMonitor(state, current) {
      state.monitorCurrent = current;
    }
  },
  actions: {
    getUserLevel: function getUserLevel(context) {
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/level/user_level')];

            case 1:
              response = _a.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                context.commit('setUserLevel', rdata.data);
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },
    getMonitorLevel: function getMonitorLevel(context) {
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/level/monitor_level')];

            case 1:
              response = _a.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                context.commit('setMonitorLevel', rdata.data);
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },
    getWelfare: function getWelfare(context, _a) {
      var type = _a.type,
          levelId = _a.levelId;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/level/welfare', {
                params: {
                  type: type,
                  id: levelId
                }
              })];

            case 1:
              response = _b.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                context.commit('setWelfare', rdata.data);
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },
    getCurrent: function getCurrent(context) {
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/level/current/user')];

            case 1:
              response = _a.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                context.commit('setCurrent', rdata.data);
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },
    getMonitor: function getMonitor(context) {
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/level/current/monitor')];

            case 1:
              response = _a.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                context.commit('setMonitor', rdata.data);
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    }
  }
};